import { render, staticRenderFns } from "./appBookFileUploader.vue?vue&type=template&id=dd0d2288"
import script from "./appBookFileUploader.vue?vue&type=script&lang=js"
export * from "./appBookFileUploader.vue?vue&type=script&lang=js"
import style0 from "./appBookFileUploader.vue?vue&type=style&index=0&id=dd0d2288&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports